import React, {useEffect, useState} from 'react';
import {Affix, Avatar, Button, Card, Layout, Menu, message, Popover} from "antd";
import {Header} from "antd/es/layout/layout";
import {UserOutlined} from "@ant-design/icons";
import Cookies from "js-cookie";
import dayjs from "dayjs";
import {useNavigate} from "react-router-dom";


const UserInfo_UI=()=>{


    const navigate=useNavigate();
    const Admin_log_out = () => {


        Cookies.remove('userToken_chattool')
        Cookies.remove('group')
        let time = dayjs().unix();
        navigate('/login?return_url=/admin/keyclick')

        return (
            console.log("111")

        );


    }


    useEffect(() => {


        setfetch_vipinfo_select_log({message:'1',value:'',time:data_time})

    }, []);



    const data_time=dayjs().unix();

    const [fetch_vipinfo_select_info, setfetch_vipinfo_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_vipinfo_select_log, setfetch_vipinfo_select_log] = useState({message: '', value: '', time: 0})
    const fetch_vipinfo = (e1: any) => {

        setfetch_vipinfo_select_log({message: 'click', value: '', time: data_time})



        setfetch_vipinfo_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_vipinfo,setreturn_data_fetch_vipinfo]=useState({
        "message": 2000,
        "value": "获取成功",
        "info": {
            "id": "1",
            "uuid": "1",
            "title": "1",
            "status": "en",
            "type": "专业",
            "value": "",
            "vip_end_time": 0,
            "is_del": "0",
            "country_uuid": "341eea77-f9ef-4157-a695-05c0f9b70761"
        }
    });

    const fetch_vipinfo_body = new FormData();


    fetch_vipinfo_body.append('uuid', fetch_vipinfo_select_info.value1);

    fetch_vipinfo_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_vipinfo_body.append('time', String(fetch_vipinfo_select_info.time));

    fetch_vipinfo_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/vip_products/fetch/fetch_vipinfo.php', {


                method: 'POST',
                body: fetch_vipinfo_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_vipinfo(return_data);

                    // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(fetch_vipinfo_select_log.message!==''){

            data_async();
            setfetch_vipinfo_select_log({message:'',value:'',time:0})
        }
    }, [fetch_vipinfo_select_log]);


    return (
        <div>

            <Layout style={{height: '100%', minHeight: '100%', overflowX: 'hidden', minWidth: 1000}}>


                <Affix offsetTop={0}>
                    <Header style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        background: "#FFFFFF",
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        zIndex: 1000, // Ensure Header is on top
                        minWidth: 1000
                    }}>

                        <h3 style={{color: "#000000", margin: 0}}>后台管理</h3>

                        <div style={{flexGrow: 1, textAlign: 'right'}}>

                            <Popover arrow={false} placement="topRight" content={<div style={{}}>

                                <Menu>

                                    <Menu.Item key="0">
                                        <label  onClick={()=>(window.open('/userinfo'))}>
                                            个人中心
                                        </label>
                                    </Menu.Item>
                                    <Menu.Item key="1">
                                        <label   onClick={Admin_log_out}>
                                            退出登录
                                        </label>
                                    </Menu.Item>
                                </Menu>

                            </div>} title="Title">
                                <Avatar size={32} icon={<UserOutlined />} />
                            </Popover>

                        </div>
                    </Header>
                </Affix>



<div style={{height:30}}>


</div>

                <Avatar size={32} icon={<UserOutlined />} />

<div style={{padding:20}}>

    <Card >
        <label style={{fontWeight:'bold',fontSize:15}}>账号信息</label>


        <p></p>

        <div style={{display:'flex'}}>

            <Avatar size={64} icon={<UserOutlined />} />

            <div style={{display:'flex',flexDirection:'column',marginLeft:10}}>
                <label>浅时光软件设计工作室</label>

                <label style={{marginTop:5}}>到期日期：{dayjs.unix(return_data_fetch_vipinfo.info.vip_end_time).format('YYYY-MM-DD')}</label>
             {/*   <Button>修改</Button>*/}

            </div>

            <Button onClick={()=>(window.open('/vipredemption'))}>兑换会员</Button>

            <Button onClick={() => {window.open('/buyvip')}}>购买会员</Button>

        </div>

    </Card>


</div>




            </Layout>
        </div>
    )
}

export default UserInfo_UI;
